import { useEffect, useState } from 'react';
import { useWeb3React } from '@web3-react/core';

import useEvilNoundleStakingPool from './useEvilNoundleStakingPool';

const useStakedEvilNoundles = () => {
  const { account } = useWeb3React();
  const stakingPool = useEvilNoundleStakingPool();

  const [stakedEvilNoundles, setStakedEvilNoundles] = useState([]);

  useEffect(() => {
    let ignore = false;
    setStakedEvilNoundles([]);
    if (stakingPool) {
      const fetchStakedEvilNoundles = () => {
        stakingPool.stakedTokens(account).then((tokenIds) => {
          if (!ignore)
            setStakedEvilNoundles(
              tokenIds.map((tokenId) => tokenId.toNumber())
            );
        });
      };
      fetchStakedEvilNoundles();
      const stake = stakingPool.filters.Stake(account);
      const unstake = stakingPool.filters.Unstake(account);

      stakingPool.on(stake, fetchStakedEvilNoundles);
      stakingPool.on(unstake, fetchStakedEvilNoundles);

      return () => {
        stakingPool.off(stake, fetchStakedEvilNoundles);
        stakingPool.off(unstake, fetchStakedEvilNoundles);
        ignore = false;
      };
    }
  }, [stakingPool, account]);

  return stakedEvilNoundles;
};

export default useStakedEvilNoundles;
